import { pageViewTypes } from "@constants/tracking";
import { ProethicaPrinciplesScreen } from "@features/proethica-principles";
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";
import { CustomAppbar } from "components/index";

const PrinciplesRoute = () => {
	useAnalytics({
		type: pageViewTypes.modules,
	});

	return (
		<>
			<CustomAppbar
				showHambugerMenu
				showCommandBar={isWeb}
				options={{
					headerTitle: "Principles",
					subtitle: "Review the ProEthica principles and guiding questions",
				}}
			/>
			<DocumentTitle title="Principles" />
			<ProethicaPrinciplesScreen />
		</>
	);
};

export default PrinciplesRoute;
